import { inject, Injectable } from '@angular/core';

import { ProjectBloc } from '@connect-services/client/blocs/project.bloc';
import { EditModeLeaveModalService } from '@connect-services/client/services/edit-mode-leave-modal.service';
import { EditModeStateService } from '@connect-services/client/services/edit-mode-state.service';
import { ProjectEditModeService } from '@connect-services/client/services/project-edit-mode.service';

export type LeaveEditModeResult = {
    canLeave: boolean;
    didDiscard: boolean;
    pendingCount: number;
};

@Injectable({
    providedIn: 'root',
})
export class EditModeLeaveService {
    private readonly editModeLeaveModalService = inject(EditModeLeaveModalService);
    private readonly editModeStateService = inject(EditModeStateService);
    private readonly projectBloc = inject(ProjectBloc);
    private readonly projectEditModeService = inject(ProjectEditModeService);

    public async requestLeaveEditMode(options?: { projectId?: string }): Promise<LeaveEditModeResult> {
        const projectId = options?.projectId ?? this.projectBloc.value()?.id;
        if (!projectId) {
            this.projectEditModeService.deactivateEditMode();

            return { canLeave: true, didDiscard: true, pendingCount: 0 };
        }

        const pendingCount = this.editModeStateService.getPendingEditCount(projectId);
        if (!pendingCount) {
            this.projectEditModeService.deactivateEditMode();

            return { canLeave: true, didDiscard: true, pendingCount: 0 };
        }

        const confirmed = await this.editModeLeaveModalService.openLeaveEditModeDialog(pendingCount);
        if (!confirmed) {
            return { canLeave: false, didDiscard: false, pendingCount };
        }

        this.editModeStateService.clearEditModeState(projectId);
        this.projectEditModeService.deactivateEditMode();

        return { canLeave: true, didDiscard: true, pendingCount };
    }
}
